import React from "react";
import Breadcrumb from "../../../../components/Breadcrumb";
import MasterLayout from "../../../../masterLayout/MasterLayout";
import ScheduleBookings from "./ScheduleBookings";

const ScheduleLayout = () => {
  return (
    <MasterLayout>
      <Breadcrumb title="Scheduled Slots" />
      <ScheduleBookings status={4} />
    </MasterLayout>
  );
};

export default ScheduleLayout;
